const Events = require('./events');

module.exports = Events;
